module.exports = __webpack_public_path__ + "static/media/value_prop_img_1.3f7b80e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-WEB/value_prop_img_1.jpg
// module id = 1431
// module chunks = 0